import React, {Component} from 'react';
import {
	Row,
	Col,
	Glyphicon,
	InputGroup,
	Button,
	FormControl
} from 'react-bootstrap';
import {Link} from 'react-router-dom';
import {LinkContainer} from 'react-router-bootstrap';
import Navigation from './Navigation';
import style from './style.less';
import './style.less';

export default class Header extends Component {
	render() {
		return (
			<Row className={style.container}>
				<Row className={style.paddings}>
					<Col md={3} mdOffset={9} sm={4} smOffset={8} xs={5} xsOffset={7}>
						<span className={style.number}>09161232165</span>
						<Glyphicon className={style.icons} glyph="align-left"/>
						<Glyphicon className={style.icons} glyph="align-left"/>
						<Glyphicon className={style.icons} glyph="align-left"/></Col>
				</Row>
				<Row>
					<Col md={5} sm={5} xs={12}>
						<h3>E COMMERCE
						</h3>
					</Col>
					<Col md={4} sm={4} xs={9}>
						<InputGroup>
							<FormControl type="text"/>
							<InputGroup.Button>
								<Button>
									<Glyphicon glyph="search"/>
								</Button>
							</InputGroup.Button>
						</InputGroup>
					</Col>
					<Col md={3} sm={3} xs={3}>
						<Glyphicon className={style.iconsHeader} glyph="shopping-cart"/>
						<Glyphicon className={style.iconsHeader} glyph="heart"/>
						<Glyphicon className={style.iconsHeader} glyph="user"/>
					</Col>
				</Row>
			</Row>
		);
	}
}



// WEBPACK FOOTER //
// ./components/header/Header.js